import { Injectable } from '@angular/core';
import { UserInfo } from '../models/user.model';
import * as moment from 'moment';
import { forkJoin, Observable } from 'rxjs';
import { UserService } from './user.service';
import { ApplicationService } from './application.service';

@Injectable()
export class AgencyContractService {

    private readonly ISP_PROGRAM_NAME = 'InternationalStudentProgram';
  private readonly STUDYABROAD_PROGRAM_NAME = 'StudyAbroadProgram';

    constructor(private userService: UserService, private applicationService: ApplicationService) {
    }

    doesAgencyHaveValidIspContractForNationality(userInfo: UserInfo, nationalityId: string) : any {
        if (!userInfo || !userInfo.IsAgent || !nationalityId)
            return true;

        const contracts = userInfo.AgencyDTO.Contracts;

        const today = moment();

        return contracts && contracts.length && 
                contracts.some(c => 
                                    c.Program === this.ISP_PROGRAM_NAME && 
                  //moment(c.EndDate).isAfter(today) &&
                  c.EligibleCountries.some(ec => ec.CountryId.toLocaleUpperCase() === nationalityId.toLocaleUpperCase()));

    }

    doesAgencyHaveValidStudyAbroadContractForNationality(userInfo: UserInfo, nationalityId: string) : any {
        if (!userInfo || !userInfo.IsAgent || !nationalityId)
            return true;

        const contracts = userInfo.AgencyDTO.Contracts;

      const today = moment();

      //console.log('-------- contracts for this agent is:', contracts);
        
        return contracts && contracts.length && 
                contracts.some(c => 
                    c.Program === this.STUDYABROAD_PROGRAM_NAME && 
                    //moment(c.EndDate).isAfter(today) && 
                  c.EligibleCountries.some(ec => ec.CountryId.toLocaleUpperCase() === nationalityId.toLocaleUpperCase()));

    }
}
